
(function() {

    'use strict';
   
    var ItxProductBulletPercentageCmp = {
        bindings: {
            percentage: '<'
        },
        controller: ItxProductBulletPercentageCtrl,
        templateUrl: 'product-bullet-percentage.component.html'
    };

    angular.module('itxApp.common')
        .component('itxProductBulletPercentage', ItxProductBulletPercentageCmp);

    ItxProductBulletPercentageCtrl.$inject = [
        'NavigationService'
    ];

    function ItxProductBulletPercentageCtrl(
        NavigationService
    ){

        var _this = this;

        _this.$onInit = () => {
            if(NavigationService.isCategoryPage()){
                _this.place = 'grid';
            } else if (NavigationService.isProductPage()) {
                _this.place = 'product';
            }

            _this.showBullet = _this.percentage && _this.place;
        };
        
    }

})();